import { Colors } from '@oy/uicore';
import { useState } from 'react';
import { useDataActivation, useEnv } from 'src/hooks';
import { useSidebarState } from '../../hooks';
import { useOverbookingData } from './useOverbookingData';

export const useBankAccountSectionImpl = () => {
  const { isProdEnv } = useEnv();
  const { isSidebarCollapsed } = useSidebarState();

  const [showTooltip, setShowTooltip] = useState(false);

  const { result } = useDataActivation();

  const isSOFActive = result?.get('SOURCE_OF_FUND')?.status === 'ACTIVE';

  const { data } = useOverbookingData(isSOFActive);

  const color = isProdEnv ? Colors.WHITE : Colors.BLACK100;

  return {
    data,
    color,
    isSidebarCollapsed,
    showTooltip,
    setShowTooltip,
  };
};
